import {
  AudienceSegmentActiveInactive,
  IAudienceSegment,
  transformAudienceSegment,
} from '~/src/dash/api/console-api';
import { generateTokenParams, IHttpResponse, restGet } from '~/src/dash/api/rest';
import { ISessionState } from '~/src/dash/reducers/session-reducers';
import { getApiDomain } from '~/src/dash/resellers/utils/importResellerConfig';
import { IMenuList } from '~/src/dash/types/menuList';

export const targetingInactiveAudienceSegments = (
  segments: IAudienceSegment[],
  segmentIDs: string,
): boolean => {
  const ids = segmentIDs.split(',');
  for (const id of ids) {
    for (const segment of segments) {
      if (segment.ID === id && segment.Active === AudienceSegmentActiveInactive) {
        return true;
      }
    }
  }

  return false;
};

export async function getAudienceSegmentsMenuList(
  session: ISessionState,
): Promise<Record<string, IMenuList>> {
  const reqUrl = `${getApiDomain()}/v1/settings/segments?${generateTokenParams(
    session.publisher.ID,
  )}`;

  return await restGet<any>(reqUrl, {})
    .then((val: IHttpResponse<any>) => {
      const audienceSegments = val.parsedBody?.segments?.map(transformAudienceSegment);

      return {
        audience_segments: generateCampaignMenuList(audienceSegments),
      };
    })
    .catch((e) => {
      console.error(e);
      return {
        audience_segments: {},
      };
    });
}

const generateCampaignMenuList = (audienceSegments: IAudienceSegment[]): IMenuList => {
  const menuList: IMenuList = {};

  audienceSegments.forEach((audienceSegment: IAudienceSegment) => {
    menuList[audienceSegment.ID] = {
      ID: String(audienceSegment.ID),
      selected: false,
      title: audienceSegment.Name,
    };
  });

  return menuList;
};
